import { put, takeEvery } from 'redux-saga/effects';
import { fetchCommonData } from '../slices/common';
import createApiInstance from '../../services/api';
import { BASE_API_URL } from '../../config';

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
}

// Dynamically create the API instance with the base URL
const api = createApiInstance(BASE_API_URL); // Replace BASE_API_URL with the dynamic value you have

/*
use when only one callback or action or both is needed
*/
function* commonAPICall(data: any) {
  let { payload } = data;
  if (payload.method) {
    try {
      const response: ResponseGenerator = yield api.request({
        method: payload.method,
        url: payload.url,
        data: payload.body || {},
      });
      if (payload.action) {
        yield put(payload.action(response));
      }
      if (payload.callback) {
        yield payload.callback(response);
      }
    } catch (error: any) {
      console.log(error);
      if (payload.errorCallback) yield payload.callback(error.response);
    }
  }
}
export default function* root() {
  yield takeEvery(fetchCommonData.type, commonAPICall);
}
